import { api } from "./client";

export type ChatMessage = {
  id: string;
  role: "user" | "assistant";
  content: string;
  revision_id: string | null;
  created_at: string;
};

export type Revision = {
  id: string;
  rationale: string;
  proposed_md: string;
  current_md: string;
  diff: string;
  base_version: number;
  status: "pending" | "accepted" | "rejected" | "superseded";
};

export type ChatState = { messages: ChatMessage[]; revision: Revision | null };
export type ChatTurn = { reply: ChatMessage; revision: Revision | null };

export const profileChatApi = {
  read: () => api.get<ChatState>("/api/profile/chat"),
  send: (content: string) => api.post<ChatTurn>("/api/profile/chat/messages", { content }),
  accept: (id: string, body_md?: string) =>
    api.post<Revision>(`/api/profile/chat/revisions/${id}/accept`, { body_md: body_md ?? null }),
  reject: (id: string) => api.post<Revision>(`/api/profile/chat/revisions/${id}/reject`, {}),
};
